import React from 'react';
import { LabelForm } from './styles';
export default function ModalLabel({
  children
}) {
  return <LabelForm data-testid="label-doc">{children}</LabelForm>;
}